import DeviceManager from '../utils/device-manager';

const SimilarPosts = {
    $swipers: [],
    swipers: {},

    init() {
        this.$swipers = document.querySelectorAll('.similar-posts-swiper');

        this.$swipers.forEach(($swiper, index) => {
            this.initSwiper($swiper, index);
        });
    },

    initSwiper($swiper, name) {
        const $slides = $swiper.querySelectorAll('.swiper-slide');

        let args = {
            updateOnWindowResize: true,
            slidesPerView: 1,
            loop: $slides.length > 1 ? true : false,
            allowTouchMove: $slides.length > 1 ? true : false,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {},
        };

        args.breakpoints[DeviceManager.devices.md] = {
            slidesPerView: 2,
            loop: $slides.length > 2 ? true : false,
            allowTouchMove: $slides.length > 2 ? true : false,
        };

        args.breakpoints[DeviceManager.devices.xl] = {
            slidesPerView: 3,
            loop: $slides.length > 3 ? true : false,
            allowTouchMove: $slides.length > 3 ? true : false,
        };

        this.swipers[name] = new Swiper($swiper, args);
    }
}

export default SimilarPosts;